module.exports = __webpack_public_path__ + "img/bg.502c7605.png";